import { observer } from 'mobx-react';
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Row } from 'react-bootstrap';
import { ErrorCode } from '../../stores/RegistrationStore';
import './RegistrationFailedStep.css';
import { RootStoreContext } from '../../stores/RootStore';
import { StepName } from '../../config/Wizard';
import errorMp3 from '../../audio/Error.mp3';
import { renderErrorMessageWithLink } from 'src/stores/ErrorMessages';
import { useNavigate } from 'react-router-dom';

const RegistrationFailedStep = observer(() => {
  const navigate = useNavigate();
  const { wizardStore: { setStep }, 
        registrationStore: { restart, error, clearError, user },
        authStore: { isUserFlow },
        studioConfigStore
      } = useContext(RootStoreContext);

  useEffect(() => {
    if (!studioConfigStore.studioConfigs) {
      studioConfigStore.fetchStudioConfigs();
    }
  }, [studioConfigStore]);

  useEffect(() => {
    const playErrorSound = async () => {
      try {
        const failAudio = new Audio(errorMp3);
        await failAudio.play();
      } catch (error) {
        console.debug('Audio play failed:', error);
      }
    };
    
    playErrorSound();
  }, []);

  const toSelectSellingItems = () => {
    clearError();
    setStep(StepName.REGISTRATION_SELECT_TRAINING);
  };

  const renderButton = (): React.JSX.Element | undefined => {
    if (isUserFlow) {
      if (error.code === ErrorCode.REGISTRATION_EXISTS_FOR_TRAINING || error.code === ErrorCode.NOT_ENOUGH_COINS) {
        return <Button variant="info" onClick={toSelectSellingItems}>Back to selection</Button>
      }
    }

    switch (error.code) {
      case ErrorCode.NOT_ENOUGH_COINS:
          return <Button variant="info" onClick={toSelectSellingItems}>Back to selection</Button>
      default:
          return <Button variant="info" onClick={restart}>Start over</Button>;
    }
  }

  const renderErrorContent = () => {
    const errorInfo = renderErrorMessageWithLink(
      error.code,
      studioConfigStore.studioHomepageStore,
      error.debtInfo,
      studioConfigStore.currencySymbol,
      error.customMessage
    );
    
    if (errorInfo.hasLink && errorInfo.linkUrl) {
      const isInternalRoute = errorInfo.linkUrl.startsWith('/');
      if (isInternalRoute && !isUserFlow) {
        return errorInfo.text;
      }

      return (
        <span>
          {errorInfo.text}{' '}
          <a
            href={errorInfo.linkUrl}
            target={isInternalRoute ? undefined : '_blank'}
            rel={isInternalRoute ? undefined : 'noopener noreferrer'}
            onClick={isInternalRoute ? (event) => {
              event.preventDefault();
              clearError();
              navigate(errorInfo.linkUrl!);
            } : undefined}
          >
             {errorInfo.linkText} 
          </a>
        </span>
      );
    }
    
    return errorInfo.text;
  };

  return (
    <Container>
      <Row>
        <Col lg={{span: 4, offset: 4}} md={{span: 6, offset: 3}} className="text-center phone">
          <Alert variant={error.level || 'danger'}>
            {renderErrorContent()}
          </Alert>
            {renderButton()}
        </Col>
      </Row>
    </Container>
  )
});

export default RegistrationFailedStep;
